<template>
  <v-row justify="center">
    <v-dialog :value="value" @input="closeAndClean()" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ localization.generarParte }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12">
                <v-layout wrap justify-center>
                  <v-flex xs12 sm12 md12 lg12 pl-1 pr-1>
                  <v-select v-model="parteSeleccionado" id="parteSeleccionado" :items="partes" item-text="nombreParte"
                    item-value="id" item-mono="monoIncidencia" :label="localization.modeloParte" :rules="[rules.required]"></v-select>
                  </v-flex>
                </v-layout>
              </v-col>
              <v-col cols="12" sm="12">
                <v-layout wrap justify-center>
                  <v-flex xs12 sm12 md12 lg12 pl-1 pr-1>
                  <v-text-field v-model="observaciones" id="observaciones" :label="localization.observaciones"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-col>
              <v-col cols="6" sm="6">
                <v-layout wrap justify-center>
                  <v-flex xs12 sm12 md12 lg12 pl-1 pr-1>
                  <v-checkbox
                    v-model="adjuntarFotosApertura" id="adjuntarFotosApertura"
                    :label="$t('adjuntarFotosApertura')"
                    color="primary"
                  />
                  </v-flex>
                </v-layout>
              </v-col>
              <v-col cols="6" sm="6">
                <v-layout wrap justify-center>
                  <v-flex xs12 sm12 md12 lg12 pl-1 pr-1>
                  <v-checkbox
                    v-model="adjuntarFotosVisita" id="adjuntarFotosVisita"
                    :label="$t('adjuntarFotosVisita')"
                    color="primary"
                  />
                  </v-flex>
                </v-layout>
              </v-col>

            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="closeAndClean()">{{localization.cerrar}}</v-btn>
          <v-btn color="primary" @click.native="enviarParte()">{{localization.generar}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

import { mapActions } from 'vuex'
import _ from 'lodash'

export default {
  props: {
    value: Boolean,
    incidenceIds: Array
  },
  data () {
    return {
      parteSeleccionado: '',
      observaciones: '',
      adjuntarFotosApertura: false,
      adjuntarFotosVisita: false,
      rules: {
        required: value => !!value || this.$t('campoObligatorio')
      }
    }
  },
  mounted () {
    this.getTiposParte()
    this.obtenerConfiguracion()
  },
  computed: {
    partes () {
      let localization = this.$t('formEnviarParte')
      if (this.$store.state.incidencias.tiposParte) {
        return this.$store.state.incidencias.tiposParte.map(x => {
          let tipo = (x.monoIncidencia === '1') ? ' - ' + localization.monoIncidencia : ' - ' + localization.multiIncidencia
          return {
            ...x,
            nombreParte: x.modelo + ' ' + tipo
          }
        })
      }
      return []
    },
    localization () {
      return this.$t('formEnviarParte')
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      obtenerConfiguracion: 'configuracion/obtenerConfiguracion',
      realizarEnvioParte: 'incidencias/realizarEnvioParte',
      getTiposParte: 'incidencias/getTiposParte'
    }),
    closeAndClean () {
      this.parteSeleccionado = ''
      this.observaciones = ''
      this.adjuntarFotosApertura = false
      this.adjuntarFotosVisita = false
      this.$emit('input')
    },
    enviarParte () {
      var ids = []
      var objetoParteSeleccionado = this.partes.find(parte => parte.id === this.parteSeleccionado)

      console.log('enviarFotos', objetoParteSeleccionado)
      if (objetoParteSeleccionado.monoIncidencia === "1" || objetoParteSeleccionado.monoIncidencia === 1) {
        this.incidenceIds.map(e => {
          ids.push(e.id)
        })
        this.enviarParteAsync({
          ids: ids,
          parteSeleccionado: this.parteSeleccionado,
          diferentesInmuebles: false,
          diferentesPromociones: false,
          observaciones: this.observaciones,
          adjuntarFotos: this.adjuntarFotosApertura,
          adjuntarFotosVisita: this.adjuntarFotosVisita,
        })
      } else {
        var configuracion = this.getConfiguracion()
        var envioMasivo = configuracion.permitirEnvioMasivo
        var inmuebleAux; var inmuebleEspecialAux; var proveedorAux; var promocionAux = ''
        var diferentesInmuebles
        var diferentesPromociones
        var validado = true
        var componente = this
        var i = 0
        _.each(this.incidenceIds, function (incidencia) {
          if (i === 0) {
            inmuebleAux = incidencia.inmueble
            inmuebleEspecialAux = incidencia.inmuEspe
            proveedorAux = incidencia.proveedor
            promocionAux = incidencia.promocion
          }

          if (envioMasivo === true) {
            if (proveedorAux !== incidencia.proveedor) {
              validado = false
            }
            diferentesInmuebles = (inmuebleAux !== incidencia.inmueble)
            diferentesPromociones = (promocionAux !== incidencia.promocion)
          } else {
            if (proveedorAux !== incidencia.proveedor || inmuebleAux !== incidencia.inmueble || promocionAux !== incidencia.promocion || inmuebleEspecialAux !== incidencia.inmuEspe) {
              validado = false
            }
          }

          if (validado === true) {
            ids.push(incidencia.id)
          }
        })

        if (validado === false) {
          var mensaje = (envioMasivo === true) ? 'Las incidencias deben ser del mismo proveedor' : 'Las incidencias deben ser del mismo proveedor, inmueble y promoción'
          componente.addAlert({texto: mensaje, color: 'error'})
          this.$emit('input')
        } else {
          this.enviarParteAsync({
            ids: ids,
            parteSeleccionado: this.parteSeleccionado,
            diferentesInmuebles: diferentesInmuebles,
            diferentesPromociones: diferentesPromociones,
            observaciones: this.observaciones,
            adjuntarFotos: this.adjuntarFotosApertura,
            adjuntarFotosVisita: this.adjuntarFotosVisita,
          })
        }
      }
    },
    getConfiguracion () {
      return this.$store.state.configuracion.configuracion
    },
    async enviarParteAsync (payload) {
      try {
        var loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false
        })
        await Promise.all([this.realizarEnvioParte(payload)])

        loader.hide()
        this.$emit('msgSuccessEnviarParte')
        this.$emit('input')
      } catch (error) {
        if (!error.code || error.code !== 1) {
          this.addAlert({ texto: error.message, color: 'error' })
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
